import Vue from "vue";
import Vuex from "vuex";
import helper from "./modules/helper";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    helper
  }
});
export default store;
